/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type { FindPendingMappingQueryResponse } from "../types/FindPendingMapping.ts"

export const findPendingMappingQueryKey = () =>
  [{ url: "/v1/client-settings/find-pending-mapping" }] as const

export type FindPendingMappingQueryKey = ReturnType<
  typeof findPendingMappingQueryKey
>

/**
 * @summary Find pending mapping
 * {@link /v1/client-settings/find-pending-mapping}
 */
export async function findPendingMapping(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindPendingMappingQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/client-settings/find-pending-mapping`,
    ...requestConfig,
  })
  return res
}

export function findPendingMappingQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findPendingMappingQueryKey()
  return queryOptions<
    ResponseConfig<FindPendingMappingQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindPendingMappingQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findPendingMapping(config)
    },
  })
}

/**
 * @summary Find pending mapping
 * {@link /v1/client-settings/find-pending-mapping}
 */
export function useFindPendingMapping<
  TData = ResponseConfig<FindPendingMappingQueryResponse>,
  TQueryData = ResponseConfig<FindPendingMappingQueryResponse>,
  TQueryKey extends QueryKey = FindPendingMappingQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindPendingMappingQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? findPendingMappingQueryKey()

  const query = useQuery(
    {
      ...findPendingMappingQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
